import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { useIndustry } from "./tokens";

interface BlueprintProps extends BoxProps {
  /** Steel-field variant: filled accent-900, marks in accent-200. */
  steel?: boolean;
  children?: React.ReactNode;
}

const CORNERS: Array<{ top?: string; bottom?: string; left?: string; right?: string }> = [
  { top: "-7px", left: "-7px" },
  { top: "-7px", right: "-7px" },
  { bottom: "-7px", left: "-7px" },
  { bottom: "-7px", right: "-7px" },
];

/**
 * Blueprint frame — 1px hairline, square corners, four "+" registration marks
 * (handoff/components.md § Blueprint frame). Transparent unless `steel`.
 */
export const Blueprint: React.FC<BlueprintProps> = ({ steel = false, children, ...rest }) => {
  const t = useIndustry();
  const mark = steel ? t.accent200 : t.mark;
  return (
    <Box
      position="relative"
      borderWidth="1px"
      borderStyle="solid"
      borderColor={steel ? t.steel : t.rule}
      bg={steel ? t.steel : "transparent"}
      borderRadius={0}
      {...rest}
    >
      {CORNERS.map((pos, i) => (
        <Box
          key={i}
          aria-hidden="true"
          position="absolute"
          w="13px"
          h="13px"
          pointerEvents="none"
          {...pos}
          _before={{
            content: '""',
            position: "absolute",
            left: 0,
            top: "6px",
            width: "13px",
            height: "1px",
            bg: mark,
          }}
          _after={{
            content: '""',
            position: "absolute",
            top: 0,
            left: "6px",
            width: "1px",
            height: "13px",
            bg: mark,
          }}
        />
      ))}
      {children}
    </Box>
  );
};
